// import { Api, auth } from '@/service';
import codes from '@/codes';
import vSelect from 'vue-select';
import { Switch as cSwitch } from '@coreui/vue';
import partnerList from '@/views/Management/partner/partner.List.i18n'

//restful api
import { auth } from '@/service'
import { signup as manager } from '@/service/api/manager';

export default {
  components: {
    partnerList,
    cSwitch,
    vSelect
  },
  data : () => ({
    codes,
    confirm: false,
    add: false,
    lock: true,
    model : { is_use: true, is_active: true, level: 'user', reason : "" },
    old_username : '',
    allowed: false,
    region : {
      language : codes.language_default,
      country : codes.country_default,
      timezone : codes.timezone_default
    },
    confirm_modal : false,
    partner_connect_modal : false,
    partner_id : 0
  }),
  computed: {
    profile() { return auth.profile; }
  },
  methods: {
    list() { this.$router.push({ name: 'signup' }); this.$emit('refresh'); },
    async get({ id, tag } = this.$route.params) {
      console.log('signup.detail.vue', 'load item', id);
      if(id === 'add') { this.add = true; this.lock = false; return; }
      try{
        this.add = false;
        this.lock = (tag != 'edit');
        let rs = await manager.detailSignup({ id : id })
        if(!rs.error) {
          this.model = Object.assign({ group: {} }, this.model, rs.body)
          let is_done_timezone = false;
          codes.timezone.forEach(r => { if(is_done_timezone) { return; } else if(this.model.timezone && r.value == this.model.timezone) { this.region.timezone = r; is_done_timezone = true } });
        } else {
          this.$toastr.e("signup user", 'load failed');
          this.list(); this.$emit('refresh');
        }
      } catch(e) { this.$toastr.e(e.data ? e.data.message ? e.data.message : e : e.statusText), this.list() }
    },
    select_partner(item) {
      this.model = Object.assign({}, this.model, { partner_id : item.id, partner : { username : item.username } })
      this.confirm_modal = true
    },
    async accept(){
      try{
        if(!this.model.partner_id || !this.model.partner || !this.model.partner.username) { return this.$toastr.e('connect partner first') }

        let rs = await manager.acceptSignup(this.model)
        if(rs.error) { console.error(rs.error, rs.reason); return this.$toastr.e('Approved failed')  }
        this.$toastr.s('Approved.'); this.list();
      } catch(e) { this.$toastr.e(e.data ? e.data.message ? e.data.message : e : e.statusText)}
    },
    async reject(){
      try{
        let rs = await manager.rejectSignup(this.model)
        if(rs.error) { console.error(rs.error, rs.reason); return this.$toastr.e('reject failed')  }
        this.$toastr.s('rejected.', "done"); this.list();
      } catch(e) { this.$toastr.e(e.data ? e.data.message ? e.data.message : e : e.statusText)}
    },
    // async remove() {
    //   try {
    //     let rs = await Api.Manager_Call('user.signup', 'remove', {id : this.model.id });
    //     if(!rs.error) {
    //       this.$toastr.s('removed.', this.$route.name);
    //     } else {
    //       this.$toastr.e('delete', "failed");
    //     }
    //     this.list(); this.$emit('refresh');
    //   } catch(e) { this.$toastr.e(e.data ? e.data.message ? e.data.message : e : e.statusText); }
    // },
  },
  watch: { '$route' (to, from) { console.log("from", from); this.get(to.params); } },
  created() { console.log('User_Detail.vue', 'created'); },
  destroyed() { console.log('User_Detail.vue', 'destroyed'); },
  mounted() {
    console.log('User_Detail.vue', 'mounted');
    this.get(this.$route.params);
  },
}